






































































































































































































































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseFormulirCard from "@/BaseFormulirCard.vue";
import CommonFormulir, { EnFormulirCategory } from "@/services/CommonFormulir";
import BaseFormulir from "@/BaseFormulir";

import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";

import pdf from "vue-pdf";
import moment from "moment";
import FormulirAsesmenFisioterapi from "@/store/modules/FormulirAsesmenFisioterapi";

type Opsi = { key: string; label: string };

const opsi = (obj: Record<string, string>): Opsi[] =>
  Object.keys(obj).map(key => ({ key, label: obj[key] }));

const RIWAYAT_DAHULU = opsi({
  ca: "CA",
  tbc: "TBC",
  hepatitis: "Hepatitis",
  dm: "DM",
  ht: "HT",
  stroke: "Stroke",
  jantung: "Jantung",
  b20: "B20",
  operasi: "Operasi",
  lainnya: "Lainnya"
});

const SIFAT_NYERI = opsi({
  tajam: "Tajam",
  tumpul: "Tumpul",
  menjalar: "Menjalar",
  terbakar: "Terbakar"
});

const ADL = opsi({
  mandiri: "Mandiri",
  bantuan_sebagian: "Bantuan Sebagian",
  bantuan_total: "Bantuan Total"
});

const MOBILITAS = opsi({
  independen: "Independen",
  tongkat: "Tongkat",
  walker: "Walker",
  kursi_roda: "Kursi roda",
  transfer: "Transfer"
});

const INTERVENSI = opsi({
  swd: "SWD",
  mwd: "MWD",
  us: "US",
  traksi: "Traksi",
  ir: "IR",
  es_nmes: "ES/NMES",
  tens: "TENS",
  paralel_bar: "Pararel Bar",
  standing_bar: "Standing Bar",
  edukasi: "Edukasi",
  exercise: "Exercise",
  manual_therapy: "Manual Therapy",
  electrotherapy: "Electrotherapy",
  dry_needling: "Dry Needling",
  breathing_exercise: "Breathing Exercise",
  balance: "Balance",
  gait_training: "Gait Training",
  mldv: "MLDV",
  crutch_walker_tripot: "Cruch/Walker/Tripot",
  static_cycle: "Static Cycle",
  parafin_bath: "Parafin Bath",
  nebulizer: "Nebulizer",
  massage: "Massage",
  massage_bayi: "Massage Bayi",
  senam_hamil: "Senam Hamil",
  senam_asthma: "Senam Asthma",
  senam_stroke: "Senam Stroke",
  cold_hot_pack: "Cold/Hot Pack",
  cpm: "CPM",
  treadmill: "Treadmill",
  leg_press: "Leg Press",
  leg_curl_extention: "Leg Curl/Extention",
  gym: "Gym",
  lainnya: "Lainnya"
});

const TTV = opsi({
  td: "TD",
  nadi: "Nadi",
  rr: "RR",
  suhu: "Suhu",
  spo2: "SpO2"
});

const FISIK = opsi({
  inspeksi: "Inspeksi",
  palpasi: "Palpasi",
  rom: "ROM",
  mmt: "MMT",
  antropometri: "Antropometri",
  sensibilitas: "Sensibilitas",
  refleks: "Refleks",
  keseimbangan: "Keseimbangan",
  gaya_berjalan: "Gaya Berjalan"
});

const TEXT_KEYS = [
  "keluhan_utama",
  "rps",
  "rpd_lainnya",
  "riwayat_pengobatan",
  "nyeri_lokasi",
  "nyeri_nrs",
  "nyeri_memperberat",
  "nyeri_mengurangi",
  "tb",
  "bb",
  "pemeriksaan_khusus",
  "adl",
  "impairment",
  "activity_limitation",
  "participation_restriction",
  "intervensi_lainnya"
]
  .concat(TTV.map(i => i.key))
  .concat(FISIK.map(i => i.key));

const ARRAY_KEYS = ["rpd", "nyeri_sifat", "mobilitas", "intervensi"];

const emptyForm = () => {
  const f: Record<string, any> = {};
  TEXT_KEYS.forEach(k => (f[k] = null));
  ARRAY_KEYS.forEach(k => (f[k] = []));
  return f;
};

@Component({
  components: {
    CardModalTtd,
    BaseFormulirCard,
    pdf
  }
})
export default class FormulirAsesmenFisioterapiTabPage extends BaseFormulir {
  @Prop() declare readonly register: string | number;

  allowedUnit = ["11"];
  formSvc = new CommonFormulir(EnFormulirCategory.AsesmenFisioterapi);
  formStore = FormulirAsesmenFisioterapi;

  riwayatDahuluItems = RIWAYAT_DAHULU;
  sifatNyeriItems = SIFAT_NYERI;
  adlItems = ADL;
  mobilitasItems = MOBILITAS;
  intervensiItems = INTERVENSI;
  ttvItems = TTV;
  fisikItems = FISIK;

  saving = false;
  loadedRatio = 0;
  validasi = [v => !!v || "*Kolom ini harus diisi"];

  tglPemeriksaanShow = false;
  tglPemeriksaan = moment().format("YYYY-MM-DD");
  form: Record<string, any> = emptyForm();

  mounted() {
    this.changedataForm(this.dataForm);
  }

  get pdfUrl() {
    return this.dataForm
      ? this.getPdfUrl(EnFormulirCategory.AsesmenFisioterapi, this.dataForm.id)
      : null;
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get imtPreview() {
    const tb = parseFloat(this.form.tb);
    const bb = parseFloat(this.form.bb);

    if (!tb || !bb) return "";

    return (Math.round((bb / Math.pow(tb / 100, 2)) * 10) / 10).toString();
  }

  get input() {
    return {
      register_id: this.register,
      pasien_rm: this.pasien.rm,
      unit_id: this.user.unit_id,
      surat_date: moment().format("YYYY-MM-DD"),
      signee_user_id: this.user.id,
      creator_user_id: this.user.id,
      content: Object.assign({}, this.form, {
        tgl_pemeriksaan: this.tglPemeriksaan,
        nyeri_nrs:
          this.form.nyeri_nrs === "" || this.form.nyeri_nrs === null
            ? null
            : Number(this.form.nyeri_nrs)
      })
    };
  }

  save() {
    if (this.saving) return;
    this.saving = true;

    const action = this.dataForm
      ? this.formSvc.update(this.dataForm.id, this.input)
      : this.formSvc.create(this.input);

    action
      .then(() => {
        appModule.NoticeDelay("Berhasil Simpan");
        this.close();
        this.formStore.getByRegister(this.register);
      })
      .finally(() => {
        this.saving = false;
      });
  }

  close() {
    this.expandInput = false;
  }

  tglPemeriksaanFormat() {
    return this.tglPemeriksaan
      ? moment(this.tglPemeriksaan, "YYYY-MM-DD").format("DD MMMM YYYY")
      : "";
  }

  @Watch("dataForm")
  changedataForm(val) {
    const c = val ? val.content || {} : {};
    const f = emptyForm();

    TEXT_KEYS.forEach(k => {
      f[k] = c[k] !== undefined && c[k] !== null ? c[k] : null;
    });
    ARRAY_KEYS.forEach(k => {
      f[k] = Array.isArray(c[k]) ? c[k].slice() : [];
    });

    this.tglPemeriksaan = c.tgl_pemeriksaan || moment().format("YYYY-MM-DD");
    this.form = f;
  }
}
